<template>
  <div class="multiselect multiselect--space-evenly">
    <MultiselectCheckbox
      v-for="(option, index) in options"
      :key="index"
      :val="index"
      v-model="decisionState"
    >
      <b>{{ option.name }}</b>
      <p>{{ option.text }}</p>
    </MultiselectCheckbox>
  </div>
</template>

<script>
import MultiselectCheckbox from "./MultiselectCheckbox.vue";

export default {
  components: {
    MultiselectCheckbox
  },
  data() {
    return {
      options: this.$t("depotfinder.decision.options")
    };
  },

  computed: {
    decisionState: {
      get() {
        return this.$store.getters.getDecisionState;
      },
      set(value) {
        this.$store.dispatch("updateDecisionState", value);
      }
    }
  }
};
</script>
